/* import { DatePicker } from "antd";
import dayjs from "dayjs";
import React from "react";
import Error from "../Error";

const Datecomponenet = React.forwardRef((props, focus) => {
  const { index, ind, val, form, setForm, getFormdata } = props;

  const handleDate = (e, index, ind) => {
    let data = [...form];
    data[index].options[ind].form.value = e?.$d;

    setForm(data);
    getFormdata(data);
  };

  const dateFormatList = ["DD/MM/YYYY", "DD-MM-YYYY"];

  return (
    <React.Fragment>
      <DatePicker
        format={dateFormatList}
        key={index?.toString()?.concat(ind)}
        id={index?.toString()?.concat(ind)}
        name={val?.form?.name}
        placeholder={val?.form?.placeholder}
        className={val?.form?.className ?? "text-regular w-full"}
        ref={focus.current[val?.form?.name + index + ind]}
        size={val?.form?.size}
        value={val?.form?.value && dayjs(val?.form?.value)}
        onChange={(e) => handleDate(e, index, ind)}
        autoComplete="off"

        onKeyDown={(e) => {
          const allowedKeys = [
            "0", "1", "2", "3", "4", "5", "6", "7", "8", "9",
            "/", "-",
            "Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"
          ];

          if (!allowedKeys.includes(e.key)) {
            e.preventDefault();
            return;
          }

          const value = e.target.value;

          if ((value.length === 0 || value.length === 1) && e.key >= "0" && e.key <= "9") return;

          if ((value.length === 2 || value.length === 5) && e.key !== "Backspace" && e.key !== "Delete") {
            e.target.value = value + "/";
          }

          if (value.length >= 10 && e.key >= "0" && e.key <= "9") {
            e.preventDefault();
          }
        }}

        onBlur={(e) => {
          const raw = e.target.value;

          if (!raw) return;

          const normalized = raw.replace(/-/g, "/");
          const parts = normalized.split("/");

          if (parts.length !== 3) {
            console.error("Invalid date format");
            return;
          }

          const [day, month, year] = parts.map(Number);

          if (day < 1 || day > 31) {
            console.error("Day must be 1-31");
            return;
          }

          if (month < 1 || month > 12) {
            console.error("Month must be 1-12");
            return;
          }

          if (year.toString().length !== 4) {
            console.error("Year must be exactly 4 digits");
            return;
          }

          handleDate({ $d: dayjs(normalized, "DD/MM/YYYY").toDate() }, index, ind);
        }}
      />

      <Error id={val?.form?.name?.concat(index + "" + ind)} />
    </React.Fragment>
  );
});

export default Datecomponenet;
 */


import { DatePicker } from "antd";
import dayjs from "dayjs";
import React from "react";
import Error from "../Error";

const Datecomponenet = React.forwardRef((props, focus) => {
  const { index, ind, val, form, setForm, getFormdata } = props;

  const handleDate = (e, index, ind) => {

    console.log("Selected Date:", e, index, ind);
    let data = [...form];
    data[index].options[ind].form.value = e?.$d;
    setForm(data);
    getFormdata(data);
  };

  const dateFormatList = ["DD/MM/YYYY", "DD-MM-YYYY"];

 
const handleKeyDown = (e) => {
  const input = e.target;
  const value = input.value;
  const cursor = input.selectionStart;

  const allowedKeys = [
    "Backspace", "Tab", "ArrowLeft", "ArrowRight",
    "Delete", "Home", "End", "Enter", "Escape"
  ];
  if (allowedKeys.includes(e.key)) return;

  // BLOCK multiple slashes
  const slashCount = (value.match(/\//g) || []).length;
  if (e.key === "/") {
    // Already have 2 slashes → BLOCK
    if (slashCount >= 2) {
      e.preventDefault();
      return;
    }

    // Only allow slash at positions 1 or 4
    if (cursor !== 1 && cursor !== 4) {
      e.preventDefault();
      return;
    }
  }

  // Only allow digits from here
  if (!/^\d$/.test(e.key)) {
    e.preventDefault();
    return;
  }

  // ---- DAY PART LOGIC ----
  if (cursor === 1) {
    const first = parseInt(value.charAt(0) || "0");
    const second = parseInt(e.key);
    const day = first * 10 + second;

    if (day < 1 || day > 31) {
      e.preventDefault();
      input.value = `0${first}/`;
      input.setSelectionRange(3, 3);
      return;
    }

    setTimeout(() => {
      if (!input.value.includes("/")) {
        input.value += "/";
        input.setSelectionRange(3, 3);
      }
    }, 0);

    return;
  }

  // ---- MONTH LOGIC ----
  if (cursor === 4) {
    const first = parseInt(value.charAt(3) || "0");
    const second = parseInt(e.key);
    const month = first * 10 + second;

    if (month < 1 || month > 12) {
      e.preventDefault();
      input.value = value.slice(0, 3) + `0${first}/`;
      input.setSelectionRange(6, 6);
      return;
    }

    setTimeout(() => {
      if (input.value.charAt(5) !== "/") {
        input.value += "/";
        input.setSelectionRange(6, 6);
      }
    }, 0);

    return;
  }

  // ---- YEAR LOGIC ----
  if (cursor >= 6) {
    const year = value.slice(6).replace(/\D/g, "");
    if (year.length >= 4) {
      e.preventDefault();
      return;
    }
  }
};


  const handleChange = (e) => {
    let val = e.target.value.replace(/[^0-9/]/g, "");

    const parts = val.split("/");

    let day = parts[0] || "";
    let month = parts[1] || "";
    let year = parts[2] || "";

    if (day.length === 2) {
      if (parseInt(day) < 1) day = "01";
      if (parseInt(day) > 31) day = "31";
    }

    if (month.length === 2) {
      if (parseInt(month) < 1) month = "01";
      if (parseInt(month) > 12) month = "12";
    }

    if (year.length > 4) {
      year = year.slice(0, 4);
    }

    let newVal = day;
    if (month) newVal += "/" + month;
    if (year) newVal += "/" + year;

    e.target.value = newVal;
  };


  const handleBlur = (e) => {
    let v = e.target.value;

    if (!v) return;

    const [d, m, y] = v.split("/");

    if (!d || !m || !y) return;

    const day = d.padStart(2, "0");
    const month = m.padStart(2, "0");
    const year = y.padStart(4, "0");

    const final = `${day}/${month}/${year}`;
    const dateObj = dayjs(final, "DD/MM/YYYY");

    if (dateObj.isValid()) {
      handleDate({ $d: dateObj.toDate() }, index, ind);
      e.target.value = final;
    }
  };

  const handlePaste = (e) => e.preventDefault();

  return (
    <React.Fragment>
      <DatePicker
        format={dateFormatList}
        key={index?.toString()?.concat(ind)}
        id={index?.toString()?.concat(ind)}
        name={val?.form?.name}
        placeholder={val?.form?.placeholder}
        className={val?.form?.className ?? "text-regular w-full"}
        ref={focus.current[val?.form?.name + index + ind]}
        size={val?.form?.size}
        value={val?.form?.value && dayjs(val?.form?.value)}
        onChange={(e) => handleDate(e, index, ind)}
        autoComplete="off"
        onKeyDown={handleKeyDown}
        onInput={handleChange}
        onBlur={handleBlur}
        onPaste={handlePaste}
        disabled={val?.form?.disabled}
      />

      <Error id={val?.form?.name?.concat(index + "" + ind)} />
    </React.Fragment>
  );
});

export default Datecomponenet;